import { portfolioAnalysisPages } from "@app/const/route.const";
import { PortfolioAnalysisDashboardPage } from "./portfolioAnalysisDashboard/PortfolioAnalysisDashboardPage";
import { EditPortfolioPage } from "./editPortfolio/EditPortfolioPage";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { PdfPortfolioAnalysisPerformanceRiskReportPage } from "./pdfPerformanceRiskReport/PdfPortfolioAnalysisPerformanceRiskReportPage";
import { PdfPortfolioAnalysisMultiPeriodReturnReportPage } from "./pdfMultiPeriodReturnReport/PdfPortfolioAnalysisMultiPeriodReturnReportPage";
import { PdfPortfolioAnalysisSectorAnalysisReportPage } from "./pdfSectorAnalysisReport/PdfPortfolioAnalysisSectorAnalysisReportPage";
import { PdfPortfolioAnalysisSimulatedForwardProbabilitiesReportPage } from "./pdfSimulatedForwardProbabilitiesReportPage/PdfPortfolioAnalysisSimulatedForwardProbabilitiesReportPage";
import { PdfPortfolioAnalysisScenarioAnalysisReportPage } from "./pdfScenarioAnalysisReport/PdfPortfolioAnalysisScenarioAnalysisReportPage";
import { PdfPortfolioAnalysisSummaryReportPage } from "./pdfSummaryReport/PdfPortfolioAnalysisSummaryReportPage";

export const PortfolioAnalysisPage = () => {
  return (
    <AccessRouteControl
      items={[
        {
          path: portfolioAnalysisPages.dashboard,
          element: <PortfolioAnalysisDashboardPage />,
          moduleSection: CarModuleSectionCode.PORTFOLIO_ANALYSIS_DASHBOARD,
        },
        {
          path: portfolioAnalysisPages.editPortfolio,
          element: <EditPortfolioPage />,
          moduleSection: CarModuleSectionCode.PORTFOLIO_ANALYSIS_EDIT_PORTFOLIO,
        },
        {
          path: portfolioAnalysisPages.pdfSummaryReportPath,
          element: <PdfPortfolioAnalysisSummaryReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_SUMMARY_REPORT,
        },
        {
          path: portfolioAnalysisPages.pdfPerformanceRiskReportPath,
          element: <PdfPortfolioAnalysisPerformanceRiskReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_PERFORMANCE_RISK_REPORT,
        },
        {
          path: portfolioAnalysisPages.pdfMultiPeriodReturnReportPath,
          element: <PdfPortfolioAnalysisMultiPeriodReturnReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_MULTI_PERIOD_RETURN_REPORT,
        },
        {
          path: portfolioAnalysisPages.pdfSimulatedForwardProbabilitiesReportPath,
          element: (
            <PdfPortfolioAnalysisSimulatedForwardProbabilitiesReportPage />
          ),
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_SIMULATED_FORWARD_PROBABILITY_REPORT,
        },
        {
          path: portfolioAnalysisPages.pdfScenarioAnalysisReportPath,
          element: <PdfPortfolioAnalysisScenarioAnalysisReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_SCENARIO_ANALYSIS_REPORT,
        },
        {
          path: portfolioAnalysisPages.pdfSectorAnalysisReportPath,
          element: <PdfPortfolioAnalysisSectorAnalysisReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_ANALYSIS_SECTOR_ANALYSIS_REPORT,
        },
      ]}
      defaultPath={portfolioAnalysisPages.dashboard}
    />
  );
};
